/* eslint-disable import/prefer-default-export */
import { cloneDeep } from 'lodash'
import { MetricSeries as MetricSeriesType } from 'schemas/MetricSeriesSchema'
import { MeasureTypeStrings } from 'enums/MeasureType'
import metricSeriesToMeasure from './metricSeriesToMeasure'

const getCompareMeasureIndexFunction = (measures: MeasureTypeStrings[]) => (
  data1: MetricSeriesType,
  data2: MetricSeriesType
) => {
  const measure1 = metricSeriesToMeasure[data1.seriesName!]
  const measure2 = metricSeriesToMeasure[data2.seriesName!]

  const measureIndex1 = measures.indexOf(measure1)
  const measureIndex2 = measures.indexOf(measure2)

  return measureIndex1 - measureIndex2
}

const getFilterByMeasuresFunction = (measures: MeasureTypeStrings[]) => (
  data: MetricSeriesType
) => {
  const measure = metricSeriesToMeasure[data.seriesName!]
  return measures!.includes(measure)
}

const getSortAndFilterByMeasuresFunction = (measures: MeasureTypeStrings[]) => {
  const compareFunction = getCompareMeasureIndexFunction(measures as MeasureTypeStrings[])
  const filterFunction = getFilterByMeasuresFunction(measures as MeasureTypeStrings[])

  return (dataset: MetricSeriesType[]) =>
    cloneDeep(dataset).sort(compareFunction).filter(filterFunction)
}

export default getSortAndFilterByMeasuresFunction
